import { Routes } from "@angular/router";
import { LoginComponent } from "./pages/login/login.component";
import { NotFoundComponent } from "./pages/not-found/not-found.component";
import { ForgotPasswordComponent } from "./pages/forgot-password/forgot-password.component";
import { MigrateComponent } from "./pages/migrate/migrate.component";
import { HomeComponent } from "./pages/home/home.component";
import { SuccessComponent } from "./pages/success/success.component";
import { OrganizationsComponent } from "./pages/organizations/organizations.component";
import { AccountSelectionComponent } from "./pages/account-selection/account-selection.component";

export const routes: Routes = [
  { path: "", component: HomeComponent },
  { path: "login", component: LoginComponent },
  { path: "migrate", component: MigrateComponent },
  { path: "organizations", component: OrganizationsComponent },
  { path: "account-selection", component: AccountSelectionComponent },
  { path: "success", component: SuccessComponent },
  { path: "forgot-password", component: ForgotPasswordComponent },
  { path: "not-found", component: NotFoundComponent },
  { path: "**", redirectTo: "" }
];
